
  export default {
    props: {
      name: { type: String, default: '' },
      value: { type: null, required: true },
      required: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      loading: { type: Boolean, default: false }
    },
    data () {
      return {
        clickedSelect: false
      };
    },
    computed: {
      selectVal: {
        get () {
          return this.value;
        },
        set (v) {
          this.$emit('input', v);
        }
      }
    },
    methods: {
      handleClick () {
        this.clickedSelect = true;
      },
      scrollToFirstError () {
        const firstError = this.$el.querySelector(':invalid');
        if (firstError && !this.clickedSelect) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.clickedSelect = false;
      },
      scrollToFirstErrorWithDelay () {
        setTimeout(() => {
          this.scrollToFirstError();
        }, 200);
      }
    }
  };
